import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SearchService } from '../../_services/search.service';
import { SortService } from '../../_services/sort.service';
import { DataTableSettings } from './datatable.settings';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
    selector: 'app-my-datatable',
    templateUrl: './datatable.component.html',
    styleUrls: ['./datatable.component.scss']
})


export class DatatableComponent implements OnInit {

    @Output() editEnd = new EventEmitter();
    @Output() viewIdsChanged = new EventEmitter<number[]>();

    @Input() hideActionFields = false;

    @Input() smallPadding = false;

    @Input() allowAdd = false;
    @Input() exclusiveAdd = false;
    @Input() allowDelete = false;

    @Input() title = '';
    @Input() settings: DataTableSettings[] = [];
    @Output() settingsChange = new EventEmitter();

    @Input() showClearFilters = false;
    @Input() showClearFiltersStyle = '';
    showClearFiltersSanitizedStyle: SafeStyle;

    @Input() showCounter = false;
    elementsCounter = 0;

    @Output() clearFilters = new EventEmitter();

    @Input()
    get elements() {
        return this.inputs;
    }
    set elements(els) {
        this.inputs = els;
        this.allInputs = els;
        this.doSort();
    }
    @Input() isDownloadingFile = false;
    @Input() isDownloadingData = false;

    @Output() elementsChange = new EventEmitter();

    inputs = [];
    private allInputs = [];

    selectAll = false;

    private checkboxFieldName = '';
    isAdding = false;


    _selected: number[] = [];
    get selected() {
        return this._selected;
    }

    set selected(s) {
        this._selected = s;
        this.selectedElementsChange.emit(s);
    }
    _hideSelected = 0;

    @Input() selectedElements: number[] = [];
    @Output() selectedElementsChange = new EventEmitter();


    @Input() allowPagination = false;
    elementsForPage = 50;
    selectedPage = 1;
    private numberOfPages = 1;
    pages: number[] = [];
    private isPageChanging = false;
    private selectablePages = 9; // Deve essere dispari per centrare correttamente la barra

    constructor(
        private _search: SearchService,
        private _sort: SortService,
        private _domSanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        this.showClearFiltersSanitizedStyle = this._domSanitizer.bypassSecurityTrustStyle(this.showClearFiltersStyle);
    }

    changeSort(idx: number) {
        for (let i = 0; i < this.settings.length; i++) {
            if (i === idx) {
                if (this.settings[i].sortValue === 0) {
                    this.settings[i].sortValue = 1;
                } else if (this.settings[i].sortValue === 1) {
                    this.settings[i].sortValue = -1;
                } else {
                    this.settings[i].sortValue = 0;
                }
            } else {
                this.settings[i].sortValue = 0;
            }
        }

        this.doSort();
    }

    doSort() {
        this.inputs = this.allInputs;

        for (let i = 0; i < this.settings.length; i++) {
            if (this.settings[i].isToSort) {
                this.inputs = this._sort.sortFilter(this.inputs, this.settings[i].sortValue, this.settings[i].fieldName);
            }
        }

        this.doSearch();
    }

    doSearch() {
        this.inputs = this.allInputs;
        for (let i = 0; i < this.settings.length; i++) {
            if (this.settings[i].isToSearch) {
                if (this.settings[i].isRangeSearch) {
                    if (this.settings[i].isDate) {
                        this.inputs = this._search.searchRangeDateFilter(this.inputs, [this.settings[i].searchValue, this.settings[i].searchRange], [this.settings[i].fieldName]);
                    } else if (this.settings[i].isDateTime) {
                        this.inputs = this._search.searchRangeDateTimeFilter(this.inputs, [this.settings[i].searchValue, this.settings[i].searchRange], [this.settings[i].fieldName]);
                    } else {
                        this.inputs = this._search.searchRangeFilter(this.inputs, [this.settings[i].searchValue, this.settings[i].searchRange], [this.settings[i].fieldName]);
                    }
                } else {
                    this.inputs = this._search.searchFilter(this.inputs, this.settings[i].searchValue, [this.settings[i].fieldName]);
                }
            }
        }
        this.elementsCounter = this.inputs.length;
        this.settingsChange.emit(this.settings);

        if (!this.isPageChanging) {
            this.selectedPage = 1;
        } else {
            this.isPageChanging = false;
        }

        this.doPaginate();
    }

    doPaginate() {
        this.numberOfPages = Math.ceil(this.inputs.length / this.elementsForPage);
        this.pages = [];
        for (let i = 1; i < this.numberOfPages + 1; i++) {
            this.pages.push(i);
        }

        let startPage = Math.max(this.selectedPage - Math.floor(this.selectablePages / 2), 1);
        if ((this.numberOfPages - startPage) < this.selectablePages) {
            startPage = Math.max(this.numberOfPages - this.selectablePages + 1, 1);
        }

        let endPage = 1;
        if (startPage === 1) {
            endPage = Math.min(this.selectablePages, this.numberOfPages);
        } else {
            endPage = Math.min(this.selectedPage + (this.selectablePages / 2), this.numberOfPages);
        }

        this.pages = this.pages.slice(startPage - 1, endPage);


        this.inputs = this.inputs.slice(this.elementsForPage * (this.selectedPage - 1), Math.min(this.elementsForPage * this.selectedPage, this.inputs.length));

        this.viewIdsChanged.emit(this.inputs.map(el => el.id));

        this._hideSelected = this._selected.length - this.inputs.filter(x => this._selected.indexOf(x.id) >= 0).length;

        if (this._hideSelected < 0) {
            this._hideSelected = 0;
        }
    }

    changePage(first, last, delta, page) {
        if (first) {
            this.selectedPage = 1;
        }
        if (last) {
            this.selectedPage = this.numberOfPages;
        }
        if (delta !== 0) {
            this.selectedPage = this.selectedPage + delta;
            if (this.selectedPage < 1) {
                this.selectedPage = 1;
            }
            if (this.selectedPage > this.numberOfPages) {
                this.selectedPage = this.numberOfPages;
            }
        }
        if (page !== 0) {
            this.selectedPage = page;
        }

        this.isPageChanging = true;

        this.doSort();
    }

    doSelectAll() {
        this.selectAll = !this.selectAll;
        if (this.selectAll) {
            this.selected = []; // Devo svuotare l'array altrimenti il metodo ngOnChanges del componente app-grouped-checkbox non viene chiamato
            this.inputs.forEach(el => {
                this.selected.push(el[this.checkboxFieldName]);
            });
        } else {
            this.selected = [];
        }
        this.elementsCounter = this.selected.length;
    }

    deSelectFiltered() {
        const support = this.selected;
        this.selected = []; // Devo svuotare l'array altrimenti il metodo ngOnChanges del componente app-grouped-checkbox non viene chiamato
        this.inputs.forEach(el => {
            if (support.indexOf(el[this.checkboxFieldName]) > -1) {
                this.selected.push(el[this.checkboxFieldName]);
            }
        });
        this.elementsCounter = this.selected.length;
    }

    isSelectDownloadField(isSelectDownloadField: boolean, fieldName: string) {
        if (isSelectDownloadField) {
            this.checkboxFieldName = fieldName;
        }

        return isSelectDownloadField;
    }


    isAnyEditable(): boolean {
        if (!this.settings || !this.settings.length || this.settings.length === 0) {
            return false;
        }
        return this.settings.filter(x => x.editable).length > 0;
    }

    isAnyDateEditable(): boolean {
        if (!this.settings || !this.settings.length || this.settings.length === 0) {
            return false;
        }
        return this.settings.filter(x => x.isDate && x.editable).length > 0;
    }

    editClicked(input) {

        if (input._edit) {
            this.isAdding = false;
            this.editEnd.emit(input);
        } else if (this.exclusiveAdd) {
            this.isAdding = true;
        }
        input._edit = !input._edit;
        this.elementsChange.emit(this.elements);
    }

    deleteClicked(input) {
        this.elements = this.elements.filter(el => el !== input);
        this.elementsChange.emit(this.elements);
    }

    addClicked() {
        if (this.exclusiveAdd) {
            this.isAdding = true;
        }

        this.elements.push({ _edit: true });
    }

    clearFiltersClicked() {
        this.clearFilters.emit();
        this.doSearch();
    }
}
